<template>
  <transition-group name="notify" tag="div" class="notify-wrapper">
    <div
        v-for="notify in notifies"
        :key="notify.id"
        class="n-notify"
        :class="notify.color"
        @click="$app.ui.closeNotify(notify.id)"
    >
      <div class="image-place">
        <img :src="notify.color === 'danger' ? imgError : imgSuccess" alt="">
      </div>

      <div class="notify-text">
        {{ notify.message }}
      </div>
    </div>
  </transition-group>
</template>


<script>
import imgSuccess from 'assets/notify/success-msg.svg'
import imgError from 'assets/notify/error-msg.svg'

export default {
  name: 'NNotify',
  data() {
    return {
      imgSuccess,
      imgError,
    }
  },
  computed: {
    notifies() {
      return $app.store.state('ui.notifies')
    },
  },
}
</script>
<style lang="scss" scoped>
.notify-wrapper {
  position: fixed;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2000;
  width: 420px;
  max-width: calc(100vw - 32px);
}

.n-notify {
  display: flex;
  align-items: center;
  gap: 12px;

  padding: 14px 18px;
  margin-bottom: 12px;

  background: #ffffff;
  border-radius: 12px;

  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  cursor: pointer;

  transition: box-shadow 0.2s ease;

  &:hover {
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.12);
  }

  &.success {
    border-left: 4px solid #1c6ef4;
  }

  &.danger {
    border-left: 4px solid rgb(236, 90, 90);
  }
}

.image-place {
  width: 28px;
  height: 28px;
  flex-shrink: 0;

  img {
    width: 100%;
    height: 100%;
  }
}

.notify-text {
  font-size: 14px;
  line-height: 1.4;
  color: #2c2c2c;
  font-weight: 500;
}

/* Анимация появления / исчезновения */
.notify-enter-active,
.notify-leave-active {
  transition: all 0.35s ease;
}

.notify-enter-from {
  opacity: 0;
  transform: translate(-50%, -10px);
}

.notify-leave-to {
  opacity: 0;
  transform: translate(-50%, -10px);
}
</style>

